import { supabase } from '../config/supabaseClient';
import { API_BASE_URL } from '../config';

export interface PreflightCheck {
  code: string;
  label: string;
  pass: boolean | null;
  value?: any;
  level?: 'info' | 'warn' | 'crit';
}

export interface CampaignPreflightResponse {
  campaign_id: string;
  mailbox_id: string;
  domain: string | null;
  since: string;
  totals: {
    totalSent: number;
    totalOpened: number;
    totalBounced: number;
    totalComplaints: number;
  };
  rates: {
    open_rate: number;
    bounce_rate: number;
    complaint_rate: number;
  };
  checks: PreflightCheck[];
  readiness: 'ready' | 'warnings' | 'blocked';
}

const buildApiUrl = (path: string): string => {
  const p = path.trim();
  const fp = p.startsWith('/') ? p : '/' + p;
  return `${API_BASE_URL.trim()}${fp}`;
};

const getToken = async () => {
  const sessionResp = await supabase.auth.getSession();
  return (sessionResp as any)?.data?.session?.access_token || '';
};

const runAuthedPost = async <T>(url: string, body?: Record<string, any>): Promise<T> => {
  const token = await getToken();
  const userResp = await supabase.auth.getUser();
  const userId = (userResp as any)?.data?.user?.id;
  if (!userId) throw new Error('User authentication required');
  const resp = await fetch(url + (url.includes('?') ? '&' : '?') + `userId=${encodeURIComponent(userId)}` , {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ ...(body || {}), userId }),
  });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `Request failed: ${resp.status}`);
  }
  return resp.json();
};

const campaignService = {
  async runPreflight(campaignId: string): Promise<CampaignPreflightResponse> {
    if (!campaignId) throw new Error('campaignId is required');
    const url = buildApiUrl(`/api/email/campaigns/${encodeURIComponent(campaignId)}/preflight`);
    return runAuthedPost<CampaignPreflightResponse>(url);
  },
};

export default campaignService;
// Types are already exported via their interface declarations above.
